var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:_vm.classList,attrs:{"id":_vm.uid,"tabindex":_vm.tabindex,"multiple":_vm.multiple,"readonly":_vm.readonly,"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d840781","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Form/Select2.vue
// module id = 1830
// module chunks = 0